(function($, undefined) {
	
	'use strict';
	var currPage;
	var calendarDay;

	var handleCalendarTouch = function(t) {
		$(t).closest('.calendar-display-day').find('.show-more-calendar-events-btn').trigger('click');
	};

	var init = function (page) {
		currPage = $(page);
        loadTouchEvents($);

		calendarDay = $('.calendar-display-day');
		calendarDay.tap(function(e) {
			e.preventDefault();
			handleCalendarTouch(e.target);
		});
	};
	
   	
	$(window).on("load",function(){
        init();
    });
})(jQuery);